import $ from "utils/net";
import PageDataFeed from "../page-data-feed";

export interface AuthResponse {
    success: boolean;
    error?: string; // 'ask-phone' o altro
}

export class MiddlewareAuthService {
    private apiUrl: string;

    constructor(middlewareUrl: string) {
        this.apiUrl = middlewareUrl;
    }

    public async authenticate(initData: string): Promise<AuthResponse> {
        try {
            const response = $.promisePostJSON(`${this.apiUrl}/api/telegram-login`, {
                json: true,
                body: JSON.stringify({ initData }),
                headers: {
                    'content-type': 'application/json'
                }
            });

            const json = await response;

            if (!json.error) {
                return { success: true };
            }

            if (json.error === 'ask-phone') {
                return { success: false, error: 'ask-phone' };
            }

            return { success: false, error: json.message || 'Unknown error' };

        } catch (error) {
            console.error("Auth Error", error);
            return { success: false, error: 'Network Error' };
        }
    }

    public async openIdConnectLogin(id_token: string): Promise<AuthResponse> {
        try {
            const response = $.promisePostJSON(`${this.apiUrl}/api/telegram-openid`, {
                json: true,
                body: JSON.stringify({ id_token: id_token }),
                headers: {
                    'content-type': 'application/json'
                }
            });

            const json = await response;

            if (!json.error) {
                await PageDataFeed.userLoginAction();
                return { success: true };
            }

            return { success: false, error: json.message || 'Unknown error' };

        } catch (error) {
            console.error("Auth Error", error);
            return { success: false, error: 'Network Error' };
        }
    }
}
